import React from "react";
import { Link } from "react-router-dom";
import { ArrowUp, MapPin } from "@phosphor-icons/react";

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_brand-builders-43/artifacts/6hieg182_Artboard%2010.svg";

const NAV = [
    { label: "Services", href: "#services" },
    { label: "Portfolio", href: "#portfolio" },
    { label: "Approche", href: "#approche" },
    { label: "Processus", href: "#processus" },
    { label: "FAQ", href: "#faq" },
    { label: "Journal", href: "/blog", internal: true },
    { label: "Contact", href: "#contact" },
];

const REGIONS_SERVED = [
    "Magog",
    "Sherbrooke",
    "Granby",
    "Bromont",
    "Orford",
    "Stanstead",
    "Coaticook",
];

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-elev border-t border-scd px-6 md:px-12 lg:px-16 pt-20 pb-10"
        >
            <div className="grid md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <a href="#top" className="inline-flex items-center gap-3">
                        <img
                            src={LOGO_URL}
                            alt="Studio Cent Douze"
                            className="h-10 w-auto"
                        />
                    </a>
                    <p className="mt-6 text-cream/65 max-w-md text-sm">
                        Studio créatif multidisciplinaire basé à Magog.
                        Sites web, photo, vidéo, création de contenu et
                        identité de marque pour les PME du Québec.
                    </p>
                </div>
                <div className="md:col-span-3">
                    <span className="label-eyebrow text-cream/60">
                        Navigation
                    </span>
                    <ul className="mt-4 space-y-3">
                        {NAV.map((n) =>
                            n.internal ? (
                                <li key={n.href}>
                                    <Link
                                        to={n.href}
                                        data-testid={`footer-link-${n.label.toLowerCase()}`}
                                        className="text-cream/85 hover-underline"
                                    >
                                        {n.label}
                                    </Link>
                                </li>
                            ) : (
                                <li key={n.href}>
                                    <a
                                        href={n.href}
                                        data-testid={`footer-link-${n.label.toLowerCase()}`}
                                        className="text-cream/85 hover-underline"
                                    >
                                        {n.label}
                                    </a>
                                </li>
                            ),
                        )}
                    </ul>
                </div>
                <div className="md:col-span-4">
                    <span className="label-eyebrow text-cream/60">Contact</span>
                    <ul className="mt-4 space-y-3 text-cream/85">
                        <li>
                            <a
                                href="mailto:bonjour@centdouze.ca"
                                className="hover-underline"
                                data-testid="footer-email"
                            >
                                bonjour@centdouze.ca
                            </a>
                        </li>
                        <li>Magog, Québec — Canada</li>
                    </ul>
                </div>
            </div>

            {/* Nous desservons — regional SEO block */}
            <div
                className="mt-16 pt-8 border-t border-scd"
                data-testid="footer-regions"
            >
                <span className="label-eyebrow text-cream/60 flex items-center gap-2">
                    <MapPin size={14} weight="fill" className="text-yellow" />
                    Nous desservons
                </span>
                <ul className="mt-4 flex flex-wrap gap-2">
                    {REGIONS_SERVED.map((city) => (
                        <li key={city}>
                            <a
                                href={`#contact`}
                                data-testid={`footer-region-${city.toLowerCase()}`}
                                title={`Studio créatif · Agence web à ${city}`}
                                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-scd text-xs text-cream/85 hover:border-yellow hover:text-yellow transition-colors"
                            >
                                {city}
                            </a>
                        </li>
                    ))}
                </ul>
                <p className="mt-3 text-[11px] text-cream/45 max-w-2xl">
                    Studio Cent Douze accompagne les PME de l&apos;Estrie et
                    des Cantons-de-l&apos;Est en création de sites web,
                    photographie professionnelle, production vidéo, création
                    de contenu et identité de marque.
                </p>
            </div>

            <div className="mt-12 pt-8 border-t border-scd flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <p className="text-xs text-cream/50">
                    © {new Date().getFullYear()} Studio Cent Douze. Tous
                    droits réservés.
                </p>
                <a
                    href="#top"
                    data-testid="footer-back-to-top"
                    className="inline-flex items-center gap-2 label-eyebrow text-cream/70 hover:text-yellow transition-colors"
                >
                    Retour en haut
                    <ArrowUp size={14} weight="bold" />
                </a>
            </div>
        </footer>
    );
}
